<nav class="app-header navbar navbar-expand-xl navbar-dark bg-dark" aria-label="Primary navigation">
  <div class="container-fluid">
    <a class="navbar-brand" routerLink="/"><img [src]="headerLogoUrl" [alt]="headerLogoAlt" height="40" /></a>

    <button class="navbar-toggler" type="button" (click)="toggleNavbar()" aria-controls="navbarNav"
      [attr.aria-expanded]="isNavbarOpen ? 'true' : 'false'" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>

    <div class="collapse navbar-collapse" id="navbarNav" #navbarCollapse>
      <button
        *ngIf="user"
        class="mobile-user-summary d-xl-none"
        type="button"
        [attr.aria-expanded]="isMobileUserMenuOpen"
        aria-controls="mobileUserMenu"
        (click)="toggleMobileUserMenu()">
        <span class="profile-picture">
          <img [src]="userPhotoUrl" [alt]="userDisplayName" />
        </span>
        <span class="profile-info">
          <span class="name">{{ userDisplayName }}</span>
          <span class="role">{{ userRoleLabel() }}</span>
        </span>
        <i class="bi" [ngClass]="isMobileUserMenuOpen ? 'bi-chevron-up' : 'bi-chevron-down'" aria-hidden="true"></i>
      </button>

      <div *ngIf="user" id="mobileUserMenu" class="mobile-userbox-menu d-xl-none" [class.show]="isMobileUserMenuOpen">
        <ul>
          <ng-container [ngTemplateOutlet]="userboxMenuItems"></ng-container>
        </ul>
      </div>

      <ul class="navbar-nav ms-auto">
        <li class="nav-item connectivity-indicator">
          <span class="badge" [ngClass]="isOnline() ? 'bg-success' : 'bg-warning text-dark'">
            {{ isOnline() ? 'Online' : 'Offline (changes will sync)' }}
          </span>
        </li>
        <ng-container *ngIf="!user">
          <li class="nav-item"><a class="nav-link" routerLink="/" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" (click)="closeNavbar()">Home</a></li>
          <li class="nav-item"><a class="nav-link" routerLink="/about" routerLinkActive="active" (click)="closeNavbar()">About</a></li>
          <li class="nav-item"><a class="nav-link" routerLink="/how-it-works" routerLinkActive="active" (click)="closeNavbar()">How It Works</a></li>
          <li class="nav-item"><a class="nav-link" routerLink="/features" routerLinkActive="active" (click)="closeNavbar()">Features</a></li>
          <li class="nav-item"><a class="nav-link" routerLink="/why-yachtapp" routerLinkActive="active" (click)="closeNavbar()">Why YachtApp</a></li>
          <li class="nav-item"><a class="nav-link" routerLink="/overview" routerLinkActive="active" (click)="closeNavbar()">Overview</a></li>
          <li class="nav-item"><a class="nav-link" routerLink="/subscriptions" routerLinkActive="active" (click)="closeNavbar()">Plans</a></li>
          <li class="nav-item"><a class="nav-link" routerLink="/contact" routerLinkActive="active" (click)="closeNavbar()">Contact</a></li>
          <li class="nav-item"><a class="nav-link" [href]="blogUrl" (click)="closeNavbar()">Blog</a></li>
          <li class="nav-item"><a class="btn btn-primary ms-2" routerLink="/login" routerLinkActive="active" (click)="closeNavbar()">Login</a></li>
        </ng-container>

        <ng-container *ngIf="user">
          <li class="nav-item"><a class="nav-link" routerLink="/dashboard" routerLinkActive="active" (click)="closeNavbar()"><i class="bi bi-grid"></i><span>Dashboard</span></a></li>
          <li class="nav-item"><a class="nav-link" routerLink="/boats" routerLinkActive="active" (click)="closeNavbar()"><i class="bi bi-water"></i><span>Boats</span></a></li>
          <li class="nav-item"><a class="nav-link" [routerLink]="maintenanceNav().link" [queryParams]="maintenanceNav().queryParams" [fragment]="maintenanceNav().fragment" (click)="closeNavbar()"><i class="bi bi-wrench-adjustable"></i><span>Maintenance</span></a></li>
          <li class="nav-item"><a class="nav-link" routerLink="/checklists" routerLinkActive="active" (click)="closeNavbar()"><i class="bi bi-card-checklist"></i><span>Checklists</span></a></li>
          <li class="nav-item"><a class="nav-link" routerLink="/inventory" routerLinkActive="active" (click)="closeNavbar()"><i class="bi bi-box-seam"></i><span>Inventory</span></a></li>
          <li class="nav-item"><a class="nav-link" routerLink="/cruises" routerLinkActive="active" (click)="closeNavbar()"><i class="bi bi-signpost-2"></i><span>Cruises</span></a></li>
          <li class="nav-item"><a class="nav-link" routerLink="/onboard" routerLinkActive="active" (click)="closeNavbar()"><i class="bi bi-people"></i><span>Crew</span></a></li>
          <li class="nav-item"><a class="nav-link" routerLink="/worklogs" routerLinkActive="active" (click)="closeNavbar()"><i class="bi bi-journal-text"></i><span>Worklogs</span></a></li>
          <li class="nav-item"><a class="nav-link" routerLink="/reminders" routerLinkActive="active" (click)="closeNavbar()"><i class="bi bi-alarm"></i><span>Reminders</span></a></li>

          <li class="nav-item d-xl-none mobile-quick-actions" [class.has-admin]="isAdmin()">
            <button class="btn btn-outline-light notification-icon" type="button" aria-label="Notifications"
              [attr.aria-expanded]="isMobileNotificationsMenuOpen" aria-controls="mobileNotificationsMenu"
              (click)="toggleMobileNotificationsMenu($event)">
              <i class="bi bi-bell"></i>
              <span class="badge" *ngIf="newNotificationsCount() > 0">{{ newNotificationsCount() }}</span>
            </button>

            <a *ngIf="isAdmin()" class="btn btn-primary admin" routerLink="/admin" routerLinkActive="active"
              (click)="closeNavbar()"><i class="bi bi-grid-1x2-fill"></i></a>
          </li>

          <li class="nav-item d-xl-none">
            <div id="mobileNotificationsMenu" class="mobile-notification-menu" [class.show]="isMobileNotificationsMenuOpen">
              <div class="notification-title">
                <span class="float-end badge badge-default">{{ newNotificationsCount() }}</span>
                Notifications
              </div>
              <ng-container [ngTemplateOutlet]="notificationsMenuItems"></ng-container>
            </div>
          </li>

          <li class="nav-item notifications d-none d-xl-block" [class.show]="isNotificationsDropdownOpen">
            <button class="btn btn-outline-light ms-2 notification-icon" type="button" aria-label="Notifications"
              [attr.aria-expanded]="isNotificationsDropdownOpen" (click)="toggleNotificationsDropdown($event)">
              <i class="bi bi-bell"></i>
              <span class="badge" *ngIf="newNotificationsCount() > 0">{{ newNotificationsCount() }}</span>
            </button>
            <div class="notification-menu" [class.show]="isNotificationsDropdownOpen">
              <div class="notification-title">
                <span class="float-end badge badge-default">{{ newNotificationsCount() }}</span>
                Notifications
              </div>
              <ng-container [ngTemplateOutlet]="notificationsMenuItems"></ng-container>
            </div>
          </li>

          <li class="nav-item userbox" [class.show]="isUserDropdownOpen">
            <button class="userbox-toggle ms-2" type="button" aria-label="User menu" [attr.aria-expanded]="isUserDropdownOpen"
              (click)="toggleUserDropdown($event)">
              <span class="profile-picture"><img [src]="userPhotoUrl" [alt]="userDisplayName" /></span>
              <span class="profile-info d-none d-xl-flex">
                <span class="name">{{ userDisplayName }}</span>
                <span class="role">{{ userRoleLabel() }}</span>
              </span>
              <i class="bi bi-chevron-down custom-caret" aria-hidden="true"></i>
            </button>
            <div class="userbox-menu" [class.show]="isUserDropdownOpen">
              <ul><ng-container [ngTemplateOutlet]="userboxMenuItems"></ng-container></ul>
            </div>
          </li>

          <li class="nav-item d-none d-lg-block" *ngIf="isAdmin()">
            <a class="btn btn-primary ms-2 admin" routerLink="/admin" routerLinkActive="active" (click)="closeNavbar()"><i class="bi bi-grid-1x2-fill"></i></a>
          </li>
        </ng-container>
      </ul>
    </div>
  </div>
</nav>

<ng-template #notificationsMenuItems>
  <div class="content">
    <ul *ngIf="recentNotifications.length; else noNotifications">
      <li *ngFor="let notification of recentNotifications; trackBy: trackNotification">
        <a class="notification-item" [routerLink]="notification.id ? ['/notifications', notification.id] : ['/notifications']" (click)="handleViewAll()">
          <ng-container *ngIf="notification | notificationPresentation as presentation">
            <span class="notification-label">{{ presentation.label }}</span>
            <span class="title">{{ presentation.title }}</span>
            <span class="message">{{ presentation.summary }}</span>
            <span class="notification-label" *ngIf="presentation.receivedAt">{{ presentation.receivedAt }}</span>
          </ng-container>
        </a>
      </li>
    </ul>
    <ng-template #noNotifications><div class="notification-empty">No notifications yet.</div></ng-template>
  </div>
  <div class="notification-footer">
    <div class="text-end"><a routerLink="/notifications" class="view-more" (click)="handleViewAll()">View All</a></div>
  </div>
</ng-template>

<ng-template #userboxMenuItems>
  <li *ngIf="hasMultipleAccounts()" class="account-switcher-section">
    <span class="menu-section-label">Switch account</span>
    <div class="account-switcher-list" role="listbox" aria-label="Account switcher">
      <button *ngFor="let account of accountOptions(); trackBy: trackAccount" type="button" class="account-switcher-item"
        [class.active]="isActiveAccount(account.accountId)" [attr.aria-selected]="isActiveAccount(account.accountId)"
        (click)="switchAccount(account.accountId)">
        <span class="account-name">{{ account.accountName }}</span>
        <span class="account-role">{{ account.roleLabel }}</span>
      </button>
    </div>
  </li>
  <li class="divider"></li>
  <li><span class="menu-meta"><i class="bi bi-building"></i>{{ activeAccountName() }}</span></li>
  <li><a routerLink="/settings" (click)="handleUserMenuClick()"><i class="bi bi-person-circle"></i>My Profile</a></li>
  <li><a routerLink="/billing" (click)="handleUserMenuClick()"><i class="bi bi-receipt"></i>Billing</a></li>
  <li><a routerLink="/users" routerLinkActive="active" (click)="handleUserMenuClick()"><i class="bi bi-people-fill"></i>Users</a></li>
  <li><a routerLink="/crewfinder" (click)="handleUserMenuClick()"><i class="bi bi-person-badge"></i>CrewFinder</a></li>
  <li><a routerLink="/activity-log" (click)="handleUserMenuClick()"><i class="bi bi-shield-lock"></i>Activity Log</a></li>
  <li><button type="button" class="logout-btn" (click)="logout()"><i class="bi bi-power"></i>Logout</button></li>
</ng-template>
